import React, { useState } from 'react';
import '../styles/News.css';
import { newsItems } from '../data/news';

const News = () => {
  const [page, setPage] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const pageSize = 2;
  const totalPages = Math.ceil(newsItems.length / pageSize);
  const start = page * pageSize;
  const visible = newsItems.slice(start, start + pageSize);

  const goToPage = (idx) => {
    if (idx === page) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setPage(idx);
      setTimeout(() => setIsTransitioning(false), 50);
    }, 300);
  };

  if (!newsItems || newsItems.length === 0) {
    return (
      <div className="news-column">
        <h2 id="news-title-html" className="section-title">NEWS</h2>
        <p style={{ color: '#666' }}>No news available.</p>
      </div>
    );
  }

  return (
    <div className="news-column">
      <h2 id="news-title-html" className="section-title">NEWS</h2>
      <div className="news-grid">
        {visible.map((item) => (
          <article key={item.id} className={`news-card ${isTransitioning ? 'swipe-out-left' : 'swipe-in'}`}>
            <div className="news-image">
              <img src={item.image} alt={item.category} loading="lazy" />
              <div className="news-category">{item.category}</div>
            </div>
            <div className="news-content">
              <h3>{item.title}</h3>
              <div className="news-date">{item.date}</div>
              <p>{item.excerpt}</p>
              <a href={item.link} className="read-more">Read More &gt;&gt;</a>
            </div>
          </article>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
        {Array.from({ length: totalPages }).map((_, idx) => (
          <span
            key={idx}
            onClick={() => goToPage(idx)}
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              margin: 4,
              cursor: 'pointer',
              background: idx === page ? '#1e3a8a' : '#cbd5e1',
              display: 'inline-block'
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default News;
